import { AuthClient } from 'pbts/c1/api/auth/v1/auth.client'
import { createUnaryApi } from 'redux_toolkit/lib/createUnaryApi'

export const getRUMApi = createUnaryApi(AuthClient, 'getRUM')
